import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { TfiCup } from "react-icons/tfi";
import { LuClock4 } from "react-icons/lu";
import { RiBookMarkLine } from "react-icons/ri";
import { TbDiscount2 } from "react-icons/tb";
import { Accordion, AccordionItem } from "@nextui-org/react";

import CourseInfo from "../../coursesAndOffers/components/CourseInfo";
import CourseDetail from "../../coursesAndOffers/components/CourseDetail";
import Button from "@/components/Button";
import AccordionHeader from "./AccordionHeader";
import { secondsToTime } from "../../../../utils/helpers";
import { useFreeLectureRedeem } from "../hooks/useFreeLectureRedeem";

function LectureItem({ lecture, innerRef }) {
    const { grade } = useParams();
    const { id, isOwned, quizzesCount, videosCount, videosDuration } = lecture;
    const { name, brief, courseId, price } = lecture.attributes;
    const [isOpen, setIsOpen] = useState(false);

    // if (videosCount === 0 && quizzesCount === 0) return null; // it make a ux problem
    const { freeLectureRedeem, isPending } = useFreeLectureRedeem();
    const navigate = useNavigate();
    function handleFreeLecture() {
        freeLectureRedeem(
            { courseId, lectureId: id },
            {
                onSuccess: () => {
                    navigate(`/${grade}/courses/${courseId}/lectures/${id}`);
                },
            }
        );
    }
    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };
    return (
        <div className="py-5">
            <Accordion variant="splitted" ref={innerRef}>
                <AccordionItem
                    key={id}
                    aria-label={name}
                    onPress={toggleAccordion}
                    title={
                        <AccordionHeader
                            isOwned={isOwned}
                            name={name}
                            border={isOpen && "border-b-1"}
                        />
                    }
                    classNames={{
                        base: isOpen
                            ? "border-2 border-primary-color-primary"
                            : "",
                    }}
                    data-open="true"
                >
                    <CourseInfo brief={brief} maxName={10} maxBrief={30} />
                    <div className="flex flex-wrap justify-center pb-5 lg:justify-between">
                        <div className="flex flex-wrap justify-start px-3 py-2 md:items-center w-fit bg-background-color md:justify-evenly rounded-xl">
                            <CourseDetail
                                title={"فيديوهات"}
                                icon={
                                    <RiBookMarkLine className="text-lg text-gray-color-primary" />
                                }
                                value={videosCount}
                            />
                            <CourseDetail
                                title={"إختبار"}
                                icon={
                                    <TfiCup className="text-lg text-gray-color-primary" />
                                }
                                value={quizzesCount}
                            />
                            <CourseDetail
                                title={"ساعات"}
                                icon={
                                    <LuClock4 className="text-lg text-gray-color-primary" />
                                } // To do: convert to houres
                                value={secondsToTime(videosDuration)}
                            />
                            <CourseDetail
                                title={"السعر"}
                                price={price}
                                icon={
                                    <TbDiscount2 className="text-xl font-black text-green-color" />
                                }
                                value={`${
                                    price === 0 ? "مجانا" : price + "جنية"
                                } `}
                            />
                        </div>
                        <div className="py-5">
                            {isOwned ? (
                                <Button
                                    to={`/${grade}/courses/${courseId}/lectures/${id}`}
                                    type="primary"
                                    className="py-3 font-medium text-center "
                                >
                                    الدخول للمحاضره
                                </Button>
                            ) : price === 0 ? (
                                <Button
                                    onClick={handleFreeLecture}
                                    type="primary"
                                    className="py-3 font-medium text-center "
                                    disabled={isPending}
                                >
                                    {isOwned ? "الدخول للمحاضره" : "اشترك الأن"}{" "}
                                </Button>
                            ) : (
                                <Button
                                    to={`/redeem/${id}`}
                                    type="primary"
                                    className="py-3 font-medium text-center "
                                >
                                    اشترك الأن
                                </Button>
                            )}
                        </div>
                    </div>
                </AccordionItem>
            </Accordion>
        </div>
    );
}

export default LectureItem;
